<form class="flex flex-1" (focusin)="showingSearchOptions.set(true)" (focusout)="onFocusOut()">
  <div class="grid grid-cols-1 w-full relative">
    <!-- Search Input : changed search from search() to onSubmit with first option preselected -->
    <input
      autocomplete="off"
      type="search"
      placeholder="{{ placeholder() }}"
      aria-label="{{ placeholder() }}"
      [class]="class()"
      enterkeyhint="search"
      [formField]="searchForm.term"
      (search)="onSubmit($event, filteringService.searchOptions()?.[0])"
      (input)="debouncedSearch($event)"
      (keydown)="handleKeyboardNavigation($event)"
      [attr.aria-activedescendant]="focusedOption()?.displayName"
      tabindex="0"
    />
    <button type="submit" (click)="onSubmit($event)" aria-label="Search" class="sr-only">
      Search
    </button>

    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      data-slot="icon"
      aria-hidden="true"
      class="col-start-1 row-start-1 ml-3 size-5 self-center text-white/75 dark:text-white/50 cursor-pointer"
      (click)="onSubmit($event, filteringService.searchOptions()?.[0])"
    >
      <path
        d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z"
        clip-rule="evenodd"
        fill-rule="evenodd"
      />
    </svg>

    <!-- swap conditional out for signal -->
    @if (showingSearchOptions() && filteringService.searchOptions().length > 0) {
      <div class="relative" #searchOptionsList>
        <ul
          #suggestionList
          class="absolute top-full max-h-50 overflow-y-auto mt-1 w-80 rounded-lg bg-white font-light dark:bg-gray-800 shadow-lg ring-1 ring-black/5 dark:ring-white/10 px-4 pt-3 pb-3 z-53"
          role="listbox"
          aria-label="search results"
        >
          <!-- <app-filters-saved class="flex flex-col gap-2" /> -->
          @for (option of filteringService.searchOptions(); track $index) {
            <li
              [id]="option.uxid"
              role="option"
              [attr.aria-selected]="$index === focusedIndex()"
              class="capitalize hover:bg-primary-500 hover:text-white rounded font-extralight text-sm"
              [class.bg-primary-500]="$index === focusedIndex()"
              [class.text-white]="$index === focusedIndex()"
            >
              <button
                class="w-full flex text-start flex-wrap cursor-pointer px-4 py-2"
                (click)="onSubmit($event, option)"
              >
                {{ option.displayName }}
              </button>
            </li>
          }
        </ul>
      </div>
    }
  </div>
</form>
